import { Form, Input, message, Modal, Upload } from "antd";
import { useState } from "react";
import AppButton from "../common/AppButton";
import { faArrowUpFromBracket, faFile } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from "xlsx";

const { TextArea } = Input;

export default function ImportPoModal({ isOpen, entityID, onClose, onSubmit, onImportPurchaseOrderLineItems, initialValues = null }) {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const handleClose = () => {
    onClose();
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".xlsx,.xls,.csv",
    showUploadList: false,

    beforeUpload: (file) => {
      handleExcelImport(file);
      return false; // prevent auto-upload
    }
  };

  const handleExcelImport = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const filteredRows = rows.filter(row =>
        Object.values(row).some(value => value !== "")
      );

      const mapped = filteredRows.map((row) => ({
        sku: String(row["Sku"] ?? "").trim(),
        description: String(row["Description"] ?? "").trim(),
        poQty: Number(row["PO Qty"] ?? 0),
        unitCost: Number(row["Unit Cost"] ?? 0),
      }));

      const missingFields = mapped.some(item => !item.sku || !item.description || !item.poQty || !item.unitCost);

      if (mapped.length === 0) {
        message.error("No valid rows found in the Excel file.");
        return;
      }
      else if (missingFields) {
        message.error("One or more rows have missing required fields (Sku, Description, PO Qty, Unit Cost). Please correct the file and try again.");
      }
      else {
        handleClose();
        onImportPurchaseOrderLineItems(mapped);
      }

    } catch (err) {
      console.error("Excel import failed:", err);
    }
  };

  const handleDownloadTemplate = () => {
    const csvContent = `Sku,Description,PO Qty,Unit Cost`;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "po_items_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      centered
      destroyOnClose
      width={520}
      title={
        <span style={{ fontSize: "20px", fontWeight: 600 }}>
          <FontAwesomeIcon className="mr-2 " icon={faFile} />
          Import PO Items
        </span>
      }
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          type: "",
          originalFileName: "",
          notes: "",
          entityType: "Container",
        }}
      >
        <Form.Item
          label="Upload Document"
          required
          validateStatus={fileList.length === 0 ? "error" : "success"}
          rules={[{ required: true, message: "Please select file" }]}
          help={fileList.length === 0 ? "Please select a file to upload" : ""}
        >
          <Upload.Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <FontAwesomeIcon icon={faArrowUpFromBracket} className="text-4xl text-[#1890ff]" />
            </p>
            <p className="ant-upload-text">
              Click or drag file here to upload
            </p>
          </Upload.Dragger>
        </Form.Item>

        <Form.Item style={{ marginTop: 24 }}>
          <div className="flex justify-end">
            <AppButton
              onClick={handleDownloadTemplate}
            >
              Download CSV Template
            </AppButton>
            <AppButton variant="close"
              onClick={handleClose}
            >
              Close
            </AppButton>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}